// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%234a6cf7%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z%27%3E%3C/path%3E%3Cpolyline points=%279 22 9 12 15 12 15 22%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_1___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2338b2ac%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z%27%3E%3C/path%3E%3Cpolyline points=%2714 2 14 8 20 8%27%3E%3C/polyline%3E%3Cline x1=%2716%27 y1=%2713%27 x2=%278%27 y2=%2713%27%3E%3C/line%3E%3Cline x1=%2716%27 y1=%2717%27 x2=%278%27 y2=%2717%27%3E%3C/line%3E%3Cpolyline points=%2710 9 9 9 8 9%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_2___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%2348bb78%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpolyline points=%279 11 12 14 22 4%27%3E%3C/polyline%3E%3Cpath d=%27M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11%27%3E%3C/path%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_URL_IMPORT_3___ = new URL("data:image/svg+xml,%3Csvg xmlns=%27http://www.w3.org/2000/svg%27 width=%2724%27 height=%2724%27 viewBox=%270 0 24 24%27 fill=%27none%27 stroke=%27%23ed8936%27 stroke-width=%272%27 stroke-linecap=%27round%27 stroke-linejoin=%27round%27%3E%3Cpath d=%27M22 11.08V12a10 10 0 1 1-5.93-9.14%27%3E%3C/path%3E%3Cpolyline points=%2722 4 12 14.01 9 11.01%27%3E%3C/polyline%3E%3C/svg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
var ___CSS_LOADER_URL_REPLACEMENT_1___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_1___);
var ___CSS_LOADER_URL_REPLACEMENT_2___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_2___);
var ___CSS_LOADER_URL_REPLACEMENT_3___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_3___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Test Cases Overview Styles */
.test-cases-overview-container {
  padding: 0;
  width: 100%;
  max-width: 100%;
  height: auto;
  min-height: 0;
  margin: 0;
  overflow: visible;
  position: relative;
  box-sizing: border-box;
  background-color: transparent;
  display: flex;
  flex-direction: column;
}

.test-cases-overview-header {
  margin-bottom: 1rem;
  flex-shrink: 0;
}

.test-cases-overview-title {
  font-size: 1.2rem;
  font-weight: 600;
  color: var(--text-dark);
  margin: 0;
}

.test-cases-overview-subtitle {
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.test-cases-overview-actions {
  display: flex;
  gap: 0.5rem;
  margin-top: 0.5rem;
}

/* Search Box */
.search-container {
  position: relative;
  flex: 0 0 220px;
  width: 220px;
  margin: 0;
}

.search-input {
  width: 100%;
  height: 36px;
  box-sizing: border-box;
  padding: 0 0.75rem 0 2rem;
  border: 1px solid #ccc;
  border-radius: 4px;
  font-size: 0.8rem;
}

.search-icon {
  position: absolute;
  left: 0.5rem;
  top: 50%;
  transform: translateY(-50%);
  color: var(--text-muted);
}

/* Filter and Sort Sections */
.test-cases-filters {
  display: flex;
  flex-wrap: wrap;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0.75rem;
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.filter-group {
  display: flex;
  flex-direction: row;
  align-items: center;
  gap: 0.5rem;
  position: relative;
  flex-shrink: 0;
}

.filter-group label {
  font-size: 0.8rem;
  color: var(--text-muted);
  line-height: 1;
  white-space: nowrap;
}

.filter-select {
  height: 36px;
  box-sizing: border-box;
  padding: 0 0.5rem;
  border-radius: 4px;
  border: 1px solid var(--border-color, #ccc);
  min-width: 100px;
  font-size: 0.8rem;
}

/* Stats Summary */
.test-cases-stats-summary {
  display: flex;
  justify-content: space-between;
  margin-bottom: 1.5rem;
  padding: 1.5rem 0;
  background-color: #ffffff;
  border-radius: 8px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  overflow: hidden;
  border: 1px solid rgba(0, 0, 0, 0.05);
}

.stat-card {
  text-align: left;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  position: relative;
  flex: 1 1;
  margin: 0 0.5rem;
  padding: 1rem 1.1rem;
  border: 1px solid rgba(15, 23, 42, 0.08);
  border-radius: 12px;
  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);
  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);
  overflow: hidden;
  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;
}

.stat-card:hover {
  border-color: color-mix(in srgb, #2563eb 28%, rgba(15, 23, 42, 0.08));
  box-shadow: 0 12px 24px -16px rgba(37, 99, 235, 0.35);
  transform: translateY(-1px);
}

.stat-card:not(:last-child)::after {
  display: none;
}

.stat-card::before {
  content: '';
  display: block;
  width: 36px;
  height: 36px;
  margin-bottom: 0.65rem;
  background-size: 20px;
  background-position: center;
  background-repeat: no-repeat;
  border-radius: 10px;
}

.stat-card:nth-child(1)::before {
  background-color: rgba(74, 108, 247, 0.1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
}

.stat-card:nth-child(2)::before {
  background-color: rgba(56, 178, 172, 0.1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_1___});
}

.stat-card:nth-child(3)::before {
  background-color: rgba(72, 187, 120, 0.1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_2___});
}

.stat-card:nth-child(4)::before {
  background-color: rgba(237, 137, 54, 0.1);
  background-image: url(${___CSS_LOADER_URL_REPLACEMENT_3___});
}

.stat-value {
  font-size: 1.5rem;
  font-weight: 700;
  color: var(--text-dark, #2d3748);
  margin: 0.5rem 0 0.25rem;
  line-height: 1;
}

.stat-value.passed {
  color: #28a745;
}

.stat-value.failed {
  color: #dc3545;
}

.stat-value.pending {
  color: #ffc107;
}

.stat-label {
  font-size: 0.7rem;
  color: var(--text-muted, #718096);
  font-weight: 500;
  letter-spacing: 0.02em;
  text-transform: uppercase;
}

/* Projects List */
.projects-list {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1 1;
  min-height: 0;
  overflow-y: auto;
}

.project-card {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  padding: 1rem;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}

.project-card:has(.project-content.expanded) {
  flex-shrink: 1;
  min-height: 0;
}

.project-header {
  margin-bottom: 0.5rem;
}

.project-header-main {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.project-title-section {
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.project-name {
  font-size: larger;
  font-weight: 600;
  margin: 0;
  color: var(--text-dark);
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
}

.project-name:hover {
  color: var(--primary-color, #007bff);
}

.project-status {
  display: inline-block;
  font-size: 0.7rem;
  font-weight: 500;
  padding: 0.15rem 0.35rem;
  border-radius: 10px;
  white-space: nowrap;
}

.project-status.status-active {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.project-status.status-inactive {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.project-status.status-completed {
  background-color: rgba(23, 162, 184, 0.1);
  color: #17a2b8;
}

.project-status.status-archived {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.project-status.status-draft {
  background-color: rgba(108, 117, 125, 0.1);
  color: #6c757d;
}

.project-description {
  color: var(--text-muted);
  margin: 0;
  font-size: 0.8rem;
}

.project-header-stats {
  display: flex;
  gap: 2rem;
  margin-left: auto;
  padding: 0.5rem 0;
}

.stat-header {
  display: flex;
  flex-direction: column;
  align-items: center;
  min-width: 50px;
  padding: 0 0.5rem;
}

.stat-header-label {

  font-size: 0.7rem;
  color: var(--text-muted);
  margin-bottom: 0.25rem;
  text-align: center;
  font-weight: 500;
  text-transform: uppercase;
  letter-spacing: 0.02em;
}
.stat-header-value {
   color: #212529;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
}
.stat-header-value.passed {
    color: #28a745;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
}
.stat-header-value.failed {
    color: #dc3545;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
}

.stat-header-value.pending {
     color: #ffc107;
  font-size: 1.5rem;
  font-weight: 700;
  line-height: 1;
}

/* Expand/Collapse Toggle */
.expand-toggle {
  background: none;
  border: none;
  width: 28px;
  height: 28px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: all 0.3s ease;
  color: var(--text-muted);
}

.expand-toggle:hover {
  background-color: rgba(0, 0, 0, 0.05);
  color: var(--primary-color, #007bff);
}

.expand-toggle.expanded svg {
  transform: rotate(180deg);
}

/* Project Actions */
.project-actions {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: 0.75rem;
  margin-bottom: 1rem;
  padding: 0;
  width: 100%;
  flex-shrink: 0;
}

.project-actions-controls {
  display: flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 0.75rem;
  flex: 1 1;
  min-width: 0;
  overflow-x: auto;
  scrollbar-width: thin;
}

.project-actions-controls::-webkit-scrollbar {
  height: 4px;
}

.project-actions-controls::-webkit-scrollbar-thumb {
  background-color: #d1d5db;
  border-radius: 4px;
}

.project-actions .navbar-button {
  padding: 0 1rem;
  border-radius: 4px;
  border: 1px solid var(--border-color, #ced4da);
  font-size: 0.85rem;
  font-weight: 500;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem;
  cursor: pointer;
  transition: all 0.2s ease;
  background-color: white;
  color: var(--text-primary, #212529);
  height: 36px;
  line-height: 1;
  box-sizing: border-box;
  flex-shrink: 0;
}

.project-actions .navbar-button:hover {
  background-color: var(--bg-light, #f8f9fa);
}

.project-actions .navbar-button.primary {
  background-color: var(--primary-color, #4a6cf7);
  color: white;
  border-color: var(--primary-color, #4a6cf7);
}

.project-actions .navbar-button.primary:hover {
  background-color: #3a5bd9;
}

.project-actions .create-test-case-btn {
  white-space: nowrap;
}

.project-actions .refresh-test-cases-btn {
  padding: 0;
  width: 36px;
  min-width: 36px;
  flex-shrink: 0;
  margin-left: auto;
}

.project-actions .refresh-test-cases-btn.refreshing svg {
  animation: spin 1s linear infinite;
}

.project-actions .refresh-test-cases-btn:disabled {
  cursor: not-allowed;
  opacity: 0.7;
}

.project-actions .navbar-button svg {
  margin-right: 0;
  vertical-align: unset;
  flex-shrink: 0;
}

.project-actions .refresh-test-cases-btn svg {
  width: 16px;
  height: 16px;
  display: block;
}

/* Project Content */
.project-content {
  display: none;
  opacity: 0;
  height: 0;
  overflow: hidden;
  transition: all 0.3s ease;
}

.project-content.expanded {
  display: flex;
  flex-direction: column;
  opacity: 1;
  height: auto;
  flex: 1 1;
  min-height: 0;
  overflow: hidden;
  animation: fadeIn 0.3s ease;
}

@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

/* Test Cases Table */
.test-cases-table-container {
  background-color: white;
  border-radius: 6px;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
  padding: 0.75rem;
  overflow: hidden;
  margin-bottom: 1rem;
  flex: 1 1;
  min-height: 0;
}

.test-cases-table-container .pagination {
  flex-shrink: 0;
  margin-top: 0.5rem;
}

.test-cases-table {
  width: 100%;
  border-collapse: collapse;
}

.test-cases-table th,
.test-cases-table td {
  padding: 0.5rem 0.75rem;
  text-align: left;
  border-bottom: 1px solid var(--border-color-light, #eee);
  font-size: 0.8rem;
}

.test-cases-table th {
  font-weight: 600;
  color: var(--text-dark);
  background-color: #f8f9fa;
}

.test-cases-table th.sortable {
  cursor: pointer;
}

.test-cases-table th.sortable:hover {
  background-color: #e9ecef;
}

.sort-indicator {
  display: inline-block;
  margin-left: 0.25rem;
}

.test-cases-table tbody tr:hover {
  background-color: rgba(0, 0, 0, 0.02);
}

/* Test Case ID cell */
.test-case-id-cell {
  display: flex;
  align-items: center;
  gap: 8px;
  white-space: nowrap;
}

.test-cases-table th.test-case-name-col,
.test-cases-table td.test-case-name {
  width: 280px;
  max-width: 280px;
  vertical-align: middle;
}

.test-cases-table th.environment-col,
.test-cases-table td.environment-cell {
  width: 140px;
  max-width: 140px;
  vertical-align: middle;
}

/* Test Case Name */
.test-case-name {
  cursor: pointer;
  color: #0066cc;
  position: relative;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test-case-name-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.environment-text {
  display: block;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.test-case-name:hover {
  text-decoration: underline;
  color: #004499;
}

.suite-link {
  color: var(--primary-color, #007bff);
  text-decoration: none;
}

.suite-link:hover {
  text-decoration: underline;
}

/* Status and Priority Badges */
.status-badge,
.priority-badge {
  display: inline-block;
  padding: 0.15rem 0.35rem;
  border-radius: 10px;
  font-size: 0.7rem;
  font-weight: 500;
}

.status-badge.status-passed {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.status-badge.status-failed {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.status-badge.status-pending {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.priority-badge.priority-high {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

.priority-badge.priority-medium {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.priority-badge.priority-low {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

/* Pass Rate */
.pass-rate {
  padding: 0.15rem 0.35rem;
  border-radius: 10px;
  font-size: 0.75rem;
  font-weight: 500;
}

.pass-rate.high {
  background-color: rgba(40, 167, 69, 0.1);
  color: #28a745;
}

.pass-rate.medium {
  background-color: rgba(255, 193, 7, 0.1);
  color: #ffc107;
}

.pass-rate.low {
  background-color: rgba(220, 53, 69, 0.1);
  color: #dc3545;
}

/* Empty State */
.test-cases-empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  text-align: center;
  padding: 2.5rem 1.5rem;
  color: var(--text-muted);
}

.test-cases-empty-state p {
  margin: 0;
  font-size: 0.9rem;
}

/* Action Feedback */
.action-feedback {
  position: fixed;
  top: 1rem;
  right: 1rem;
  padding: 0.75rem 1rem;
  border-radius: 6px;
  background-color: white;
  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);
  display: flex;
  align-items: center;
  gap: 0.5rem;
  z-index: 1000;
  animation: slideIn 0.3s ease;
}

.action-feedback.success {
  border-left: 4px solid #28a745;
}

.action-feedback.error {
  border-left: 4px solid #dc3545;
}

.action-feedback.info {
  border-left: 4px solid #17a2b8;
}

.action-feedback button {
  background: none;
  border: none;
  font-size: 1rem;
  cursor: pointer;
  color: var(--text-muted);
}

@keyframes slideIn {
  from {
    transform: translateX(100%);
    opacity: 0;
  }
  to {
    transform: translateX(0);
    opacity: 1;
  }
}

/* Loading and Error States */
.loading-container,
.error-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 2rem;
  text-align: center;
}

.loading-spinner {
  width: 40px;
  height: 40px;
  border: 3px solid rgba(0, 0, 0, 0.1);
  border-radius: 50%;
  border-top-color: var(--primary-color, #007bff);
  animation: spin 1s ease-in-out infinite;
  margin-bottom: 1rem;
}

@keyframes spin {
  to {
    transform: rotate(360deg);
  }
}

.error-icon {
  font-size: 2rem;
  margin-bottom: 1rem;
}

/* Responsive Adjustments */
@media (max-width: 768px) {
  .test-cases-stats-summary {
    flex-wrap: wrap;
  }
  
  .stat-card {
    flex: 1 0 40%;
    margin-bottom: 1rem;
  }
  
  .project-header-stats {
    flex-wrap: wrap;
    justify-content: flex-end;
  }
}

@media (max-width: 576px) {
  .test-cases-overview-header {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .test-cases-overview-actions {
    margin-top: 1rem;
    width: 100%;
  }
  
  .project-header-main {
    flex-direction: column;
    align-items: flex-start;
  }
  
  .expand-toggle {
    position: absolute;
    top: 1rem;
    right: 1rem;
  }
  
  .project-card {
    position: relative;
  }
}

.filter-loading {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  pointer-events: none;
}

.spinner-small {
  width: 16px;
  height: 16px;
  border: 2px solid #f3f3f3;
  border-top: 2px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
}

@keyframes spin {
  0% { transform: rotate(0deg); }
  100% { transform: rotate(360deg); }
}

/* Test Cases Loading Styles */
.test-cases-loading {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 3rem 1rem;
  text-align: center;
  color: #666;
}

.test-cases-loading .loading-spinner {
  width: 32px;
  height: 32px;
  border: 3px solid #f3f3f3;
  border-top: 3px solid #007bff;
  border-radius: 50%;
  animation: spin 1s linear infinite;
  margin-bottom: 1rem;
}

.test-cases-loading p {
  margin: 0;
  font-size: 0.9rem;
  color: #666;
}

/* Search Loading Styles */
.search-loading {
  position: absolute;
  right: 8px;
  top: 50%;
  transform: translateY(-50%);
  z-index: 1;
  pointer-events: none;
}`, "",{"version":3,"sources":["webpack://./src/styles/test-cases-overview.css"],"names":[],"mappings":"AAAA,+BAA+B;AAC/B;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,YAAY;EACZ,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,kBAAkB;EAClB,sBAAsB;EACtB,6BAA6B;EAC7B,aAAa;EACb,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,uBAAuB;EACvB,SAAS;AACX;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,WAAW;EACX,kBAAkB;AACpB;;AAEA,eAAe;AACf;EACE,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,SAAS;AACX;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,yBAAyB;EACzB,sBAAsB;EACtB,kBAAkB;EAClB,iBAAiB;AACnB;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,QAAQ;EACR,2BAA2B;EAC3B,wBAAwB;AAC1B;;AAEA,6BAA6B;AAC7B;EACE,aAAa;EACb,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;AAC3C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;EACxB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,sBAAsB;EACtB,iBAAiB;EACjB,kBAAkB;EAClB,2CAA2C;EAC3C,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,iBAAiB;EACjB,yBAAyB;EACzB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,qCAAqC;AACvC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;EAClB,SAAO;EACP,gBAAgB;EAChB,oBAAoB;EACpB,wCAAwC;EACxC,mBAAmB;EACnB,0DAA0D;EAC1D,4CAA4C;EAC5C,gBAAgB;EAChB,gFAAgF;AAClF;;AAEA;EACE,qEAAqE;EACrE,qDAAqD;EACrD,2BAA2B;AAC7B;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,WAAW;EACX,cAAc;EACd,WAAW;EACX,YAAY;EACZ,sBAAsB;EACtB,qBAAqB;EACrB,2BAA2B;EAC3B,4BAA4B;EAC5B,mBAAmB;AACrB;;AAEA;EACE,yCAAyC;EACzC,yDAAgX;AAClX;;AAEA;EACE,yCAAyC;EACzC,yDAAghB;AAClhB;;AAEA;EACE,yCAAyC;EACzC,yDAAqX;AACvX;;AAEA;EACE,yCAAyC;EACzC,yDAAoW;AACtW;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,gCAAgC;EAChC,wBAAwB;EACxB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,iCAAiC;EACjC,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;AAC3B;;AAEA,kBAAkB;AAClB;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;EACT,SAAO;EACP,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,aAAa;EACb,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,aAAa;AACf;;AAEA;EACE,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,SAAS;EACT,uBAAuB;EACvB,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,oCAAoC;AACtC;;AAEA;EACE,qBAAqB;EACrB,iBAAiB;EACjB,gBAAgB;EAChB,wBAAwB;EACxB,mBAAmB;EACnB,mBAAmB;AACrB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,yCAAyC;EACzC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,0CAA0C;EAC1C,cAAc;AAChB;;AAEA;EACE,wBAAwB;EACxB,SAAS;EACT,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,eAAe;EACf,iBAAiB;AACnB;;AAEA;;EAEE,iBAAiB;EACjB,wBAAwB;EACxB,sBAAsB;EACtB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;AACxB;AACA;GACG,cAAc;EACf,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;IACI,cAAc;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;AACA;IACI,cAAc;EAChB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;KACK,cAAc;EACjB,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA,2BAA2B;AAC3B;EACE,gBAAgB;EAChB,YAAY;EACZ,WAAW;EACX,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,yBAAyB;EACzB,wBAAwB;AAC1B;;AAEA;EACE,qCAAqC;EACrC,oCAAoC;AACtC;;AAEA;EACE,yBAAyB;AAC3B;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,8BAA8B;EAC9B,YAAY;EACZ,mBAAmB;EACnB,UAAU;EACV,WAAW;EACX,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,YAAY;EACZ,SAAO;EACP,YAAY;EACZ,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,WAAW;AACb;;AAEA;EACE,yBAAyB;EACzB,kBAAkB;AACpB;;AAEA;EACE,eAAe;EACf,kBAAkB;EAClB,8CAA8C;EAC9C,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,uBAAuB;EACvB,mCAAmC;EACnC,YAAY;EACZ,cAAc;EACd,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,0CAA0C;AAC5C;;AAEA;EACE,+CAA+C;EAC/C,YAAY;EACZ,2CAA2C;AAC7C;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,UAAU;EACV,WAAW;EACX,eAAe;EACf,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,mBAAmB;EACnB,YAAY;AACd;;AAEA;EACE,eAAe;EACf,qBAAqB;EACrB,cAAc;AAChB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,aAAa;EACb,UAAU;EACV,SAAS;EACT,gBAAgB;EAChB,yBAAyB;AAC3B;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,UAAU;EACV,YAAY;EACZ,SAAO;EACP,aAAa;EACb,gBAAgB;EAChB,2BAA2B;AAC7B;;AAEA;EACE;IACE,UAAU;IACV,4BAA4B;EAC9B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF;;AAEA,qBAAqB;AACrB;EACE,uBAAuB;EACvB,kBAAkB;EAClB,yCAAyC;EACzC,gBAAgB;EAChB,gBAAgB;EAChB,mBAAmB;EACnB,SAAO;EACP,aAAa;AACf;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,uBAAuB;EACvB,gBAAgB;EAChB,wDAAwD;EACxD,iBAAiB;AACnB;;AAEA;EACE,gBAAgB;EAChB,uBAAuB;EACvB,yBAAyB;AAC3B;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,qBAAqB;EACrB,oBAAoB;AACtB;;AAEA;EACE,qCAAqC;AACvC;;AAEA,sBAAsB;AACtB;EACE,aAAa;EACb,mBAAmB;EACnB,QAAQ;EACR,mBAAmB;AACrB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA;;EAEE,YAAY;EACZ,gBAAgB;EAChB,sBAAsB;AACxB;;AAEA,mBAAmB;AACnB;EACE,eAAe;EACf,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,0BAA0B;EAC1B,cAAc;AAChB;;AAEA;EACE,oCAAoC;EACpC,qBAAqB;AACvB;;AAEA;EACE,0BAA0B;AAC5B;;AAEA,+BAA+B;AAC/B;;EAEE,qBAAqB;EACrB,wBAAwB;EACxB,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,cAAc;AACd;EACE,wBAAwB;EACxB,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA;EACE,wCAAwC;EACxC,cAAc;AAChB;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,kBAAkB;EAClB,sBAAsB;EACtB,wBAAwB;AAC1B;;AAEA;EACE,SAAS;EACT,iBAAiB;AACnB;;AAEA,oBAAoB;AACpB;EACE,eAAe;EACf,SAAS;EACT,WAAW;EACX,qBAAqB;EACrB,kBAAkB;EAClB,uBAAuB;EACvB,yCAAyC;EACzC,aAAa;EACb,mBAAmB;EACnB,WAAW;EACX,aAAa;EACb,4BAA4B;AAC9B;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,eAAe;EACf,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE;IACE,2BAA2B;IAC3B,UAAU;EACZ;EACA;IACE,wBAAwB;IACxB,UAAU;EACZ;AACF;;AAEA,6BAA6B;AAC7B;;EAEE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,oCAAoC;EACpC,kBAAkB;EAClB,+CAA+C;EAC/C,uCAAuC;EACvC,mBAAmB;AACrB;;AAEA;EACE;IACE,yBAAyB;EAC3B;AACF;;AAEA;EACE,eAAe;EACf,mBAAmB;AACrB;;AAEA,2BAA2B;AAC3B;EACE;IACE,eAAe;EACjB;;EAEA;IACE,aAAa;IACb,mBAAmB;EACrB;;EAEA;IACE,eAAe;IACf,yBAAyB;EAC3B;AACF;;AAEA;EACE;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,gBAAgB;IAChB,WAAW;EACb;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;EACzB;;EAEA;IACE,kBAAkB;IAClB,SAAS;IACT,WAAW;EACb;;EAEA;IACE,kBAAkB;EACpB;AACF;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;AACpC;;AAEA;EACE,KAAK,uBAAuB,EAAE;EAC9B,OAAO,yBAAyB,EAAE;AACpC;;AAEA,8BAA8B;AAC9B;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;EAClB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,yBAAyB;EACzB,6BAA6B;EAC7B,kBAAkB;EAClB,kCAAkC;EAClC,mBAAmB;AACrB;;AAEA;EACE,SAAS;EACT,iBAAiB;EACjB,WAAW;AACb;;AAEA,0BAA0B;AAC1B;EACE,kBAAkB;EAClB,UAAU;EACV,QAAQ;EACR,2BAA2B;EAC3B,UAAU;EACV,oBAAoB;AACtB","sourcesContent":["/* Test Cases Overview Styles */\n.test-cases-overview-container {\n  padding: 0;\n  width: 100%;\n  max-width: 100%;\n  height: auto;\n  min-height: 0;\n  margin: 0;\n  overflow: visible;\n  position: relative;\n  box-sizing: border-box;\n  background-color: transparent;\n  display: flex;\n  flex-direction: column;\n}\n\n.test-cases-overview-header {\n  margin-bottom: 1rem;\n  flex-shrink: 0;\n}\n\n.test-cases-overview-title {\n  font-size: 1.2rem;\n  font-weight: 600;\n  color: var(--text-dark);\n  margin: 0;\n}\n\n.test-cases-overview-subtitle {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n}\n\n.test-cases-overview-actions {\n  display: flex;\n  gap: 0.5rem;\n  margin-top: 0.5rem;\n}\n\n/* Search Box */\n.search-container {\n  position: relative;\n  flex: 0 0 220px;\n  width: 220px;\n  margin: 0;\n}\n\n.search-input {\n  width: 100%;\n  height: 36px;\n  box-sizing: border-box;\n  padding: 0 0.75rem 0 2rem;\n  border: 1px solid #ccc;\n  border-radius: 4px;\n  font-size: 0.8rem;\n}\n\n.search-icon {\n  position: absolute;\n  left: 0.5rem;\n  top: 50%;\n  transform: translateY(-50%);\n  color: var(--text-muted);\n}\n\n/* Filter and Sort Sections */\n.test-cases-filters {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding: 0.75rem;\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n}\n\n.filter-group {\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  gap: 0.5rem;\n  position: relative;\n  flex-shrink: 0;\n}\n\n.filter-group label {\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  line-height: 1;\n  white-space: nowrap;\n}\n\n.filter-select {\n  height: 36px;\n  box-sizing: border-box;\n  padding: 0 0.5rem;\n  border-radius: 4px;\n  border: 1px solid var(--border-color, #ccc);\n  min-width: 100px;\n  font-size: 0.8rem;\n}\n\n/* Stats Summary */\n.test-cases-stats-summary {\n  display: flex;\n  justify-content: space-between;\n  margin-bottom: 1.5rem;\n  padding: 1.5rem 0;\n  background-color: #ffffff;\n  border-radius: 8px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  overflow: hidden;\n  border: 1px solid rgba(0, 0, 0, 0.05);\n}\n\n.stat-card {\n  text-align: left;\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n  position: relative;\n  flex: 1;\n  margin: 0 0.5rem;\n  padding: 1rem 1.1rem;\n  border: 1px solid rgba(15, 23, 42, 0.08);\n  border-radius: 12px;\n  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);\n  box-shadow: 0 1px 2px rgba(15, 23, 42, 0.04);\n  overflow: hidden;\n  transition: border-color 160ms ease, box-shadow 160ms ease, transform 160ms ease;\n}\n\n.stat-card:hover {\n  border-color: color-mix(in srgb, #2563eb 28%, rgba(15, 23, 42, 0.08));\n  box-shadow: 0 12px 24px -16px rgba(37, 99, 235, 0.35);\n  transform: translateY(-1px);\n}\n\n.stat-card:not(:last-child)::after {\n  display: none;\n}\n\n.stat-card::before {\n  content: '';\n  display: block;\n  width: 36px;\n  height: 36px;\n  margin-bottom: 0.65rem;\n  background-size: 20px;\n  background-position: center;\n  background-repeat: no-repeat;\n  border-radius: 10px;\n}\n\n.stat-card:nth-child(1)::before {\n  background-color: rgba(74, 108, 247, 0.1);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%234a6cf7' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z'%3E%3C/path%3E%3Cpolyline points='9 22 9 12 15 12 15 22'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n\n.stat-card:nth-child(2)::before {\n  background-color: rgba(56, 178, 172, 0.1);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2338b2ac' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z'%3E%3C/path%3E%3Cpolyline points='14 2 14 8 20 8'%3E%3C/polyline%3E%3Cline x1='16' y1='13' x2='8' y2='13'%3E%3C/line%3E%3Cline x1='16' y1='17' x2='8' y2='17'%3E%3C/line%3E%3Cpolyline points='10 9 9 9 8 9'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n\n.stat-card:nth-child(3)::before {\n  background-color: rgba(72, 187, 120, 0.1);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%2348bb78' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpolyline points='9 11 12 14 22 4'%3E%3C/polyline%3E%3Cpath d='M21 12v7a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11'%3E%3C/path%3E%3C/svg%3E\");\n}\n\n.stat-card:nth-child(4)::before {\n  background-color: rgba(237, 137, 54, 0.1);\n  background-image: url(\"data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='24' height='24' viewBox='0 0 24 24' fill='none' stroke='%23ed8936' stroke-width='2' stroke-linecap='round' stroke-linejoin='round'%3E%3Cpath d='M22 11.08V12a10 10 0 1 1-5.93-9.14'%3E%3C/path%3E%3Cpolyline points='22 4 12 14.01 9 11.01'%3E%3C/polyline%3E%3C/svg%3E\");\n}\n\n.stat-value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: var(--text-dark, #2d3748);\n  margin: 0.5rem 0 0.25rem;\n  line-height: 1;\n}\n\n.stat-value.passed {\n  color: #28a745;\n}\n\n.stat-value.failed {\n  color: #dc3545;\n}\n\n.stat-value.pending {\n  color: #ffc107;\n}\n\n.stat-label {\n  font-size: 0.7rem;\n  color: var(--text-muted, #718096);\n  font-weight: 500;\n  letter-spacing: 0.02em;\n  text-transform: uppercase;\n}\n\n/* Projects List */\n.projects-list {\n  display: flex;\n  flex-direction: column;\n  gap: 1rem;\n  flex: 1;\n  min-height: 0;\n  overflow-y: auto;\n}\n\n.project-card {\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  padding: 1rem;\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  flex-shrink: 0;\n}\n\n.project-card:has(.project-content.expanded) {\n  flex-shrink: 1;\n  min-height: 0;\n}\n\n.project-header {\n  margin-bottom: 0.5rem;\n}\n\n.project-header-main {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  width: 100%;\n}\n\n.project-title-section {\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.project-name {\n  font-size: larger;\n  font-weight: 600;\n  margin: 0;\n  color: var(--text-dark);\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.project-name:hover {\n  color: var(--primary-color, #007bff);\n}\n\n.project-status {\n  display: inline-block;\n  font-size: 0.7rem;\n  font-weight: 500;\n  padding: 0.15rem 0.35rem;\n  border-radius: 10px;\n  white-space: nowrap;\n}\n\n.project-status.status-active {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.project-status.status-inactive {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.project-status.status-completed {\n  background-color: rgba(23, 162, 184, 0.1);\n  color: #17a2b8;\n}\n\n.project-status.status-archived {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.project-status.status-draft {\n  background-color: rgba(108, 117, 125, 0.1);\n  color: #6c757d;\n}\n\n.project-description {\n  color: var(--text-muted);\n  margin: 0;\n  font-size: 0.8rem;\n}\n\n.project-header-stats {\n  display: flex;\n  gap: 2rem;\n  margin-left: auto;\n  padding: 0.5rem 0;\n}\n\n.stat-header {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  min-width: 50px;\n  padding: 0 0.5rem;\n}\n\n.stat-header-label {\n\n  font-size: 0.7rem;\n  color: var(--text-muted);\n  margin-bottom: 0.25rem;\n  text-align: center;\n  font-weight: 500;\n  text-transform: uppercase;\n  letter-spacing: 0.02em;\n}\n.stat-header-value {\n   color: #212529;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n}\n.stat-header-value.passed {\n    color: #28a745;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n}\n.stat-header-value.failed {\n    color: #dc3545;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n.stat-header-value.pending {\n     color: #ffc107;\n  font-size: 1.5rem;\n  font-weight: 700;\n  line-height: 1;\n}\n\n/* Expand/Collapse Toggle */\n.expand-toggle {\n  background: none;\n  border: none;\n  width: 28px;\n  height: 28px;\n  border-radius: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  cursor: pointer;\n  transition: all 0.3s ease;\n  color: var(--text-muted);\n}\n\n.expand-toggle:hover {\n  background-color: rgba(0, 0, 0, 0.05);\n  color: var(--primary-color, #007bff);\n}\n\n.expand-toggle.expanded svg {\n  transform: rotate(180deg);\n}\n\n/* Project Actions */\n.project-actions {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.75rem;\n  margin-bottom: 1rem;\n  padding: 0;\n  width: 100%;\n  flex-shrink: 0;\n}\n\n.project-actions-controls {\n  display: flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 0.75rem;\n  flex: 1;\n  min-width: 0;\n  overflow-x: auto;\n  scrollbar-width: thin;\n}\n\n.project-actions-controls::-webkit-scrollbar {\n  height: 4px;\n}\n\n.project-actions-controls::-webkit-scrollbar-thumb {\n  background-color: #d1d5db;\n  border-radius: 4px;\n}\n\n.project-actions .navbar-button {\n  padding: 0 1rem;\n  border-radius: 4px;\n  border: 1px solid var(--border-color, #ced4da);\n  font-size: 0.85rem;\n  font-weight: 500;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  gap: 0.5rem;\n  cursor: pointer;\n  transition: all 0.2s ease;\n  background-color: white;\n  color: var(--text-primary, #212529);\n  height: 36px;\n  line-height: 1;\n  box-sizing: border-box;\n  flex-shrink: 0;\n}\n\n.project-actions .navbar-button:hover {\n  background-color: var(--bg-light, #f8f9fa);\n}\n\n.project-actions .navbar-button.primary {\n  background-color: var(--primary-color, #4a6cf7);\n  color: white;\n  border-color: var(--primary-color, #4a6cf7);\n}\n\n.project-actions .navbar-button.primary:hover {\n  background-color: #3a5bd9;\n}\n\n.project-actions .create-test-case-btn {\n  white-space: nowrap;\n}\n\n.project-actions .refresh-test-cases-btn {\n  padding: 0;\n  width: 36px;\n  min-width: 36px;\n  flex-shrink: 0;\n  margin-left: auto;\n}\n\n.project-actions .refresh-test-cases-btn.refreshing svg {\n  animation: spin 1s linear infinite;\n}\n\n.project-actions .refresh-test-cases-btn:disabled {\n  cursor: not-allowed;\n  opacity: 0.7;\n}\n\n.project-actions .navbar-button svg {\n  margin-right: 0;\n  vertical-align: unset;\n  flex-shrink: 0;\n}\n\n.project-actions .refresh-test-cases-btn svg {\n  width: 16px;\n  height: 16px;\n  display: block;\n}\n\n/* Project Content */\n.project-content {\n  display: none;\n  opacity: 0;\n  height: 0;\n  overflow: hidden;\n  transition: all 0.3s ease;\n}\n\n.project-content.expanded {\n  display: flex;\n  flex-direction: column;\n  opacity: 1;\n  height: auto;\n  flex: 1;\n  min-height: 0;\n  overflow: hidden;\n  animation: fadeIn 0.3s ease;\n}\n\n@keyframes fadeIn {\n  from {\n    opacity: 0;\n    transform: translateY(-10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n\n/* Test Cases Table */\n.test-cases-table-container {\n  background-color: white;\n  border-radius: 6px;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);\n  padding: 0.75rem;\n  overflow: hidden;\n  margin-bottom: 1rem;\n  flex: 1;\n  min-height: 0;\n}\n\n.test-cases-table-container .pagination {\n  flex-shrink: 0;\n  margin-top: 0.5rem;\n}\n\n.test-cases-table {\n  width: 100%;\n  border-collapse: collapse;\n}\n\n.test-cases-table th,\n.test-cases-table td {\n  padding: 0.5rem 0.75rem;\n  text-align: left;\n  border-bottom: 1px solid var(--border-color-light, #eee);\n  font-size: 0.8rem;\n}\n\n.test-cases-table th {\n  font-weight: 600;\n  color: var(--text-dark);\n  background-color: #f8f9fa;\n}\n\n.test-cases-table th.sortable {\n  cursor: pointer;\n}\n\n.test-cases-table th.sortable:hover {\n  background-color: #e9ecef;\n}\n\n.sort-indicator {\n  display: inline-block;\n  margin-left: 0.25rem;\n}\n\n.test-cases-table tbody tr:hover {\n  background-color: rgba(0, 0, 0, 0.02);\n}\n\n/* Test Case ID cell */\n.test-case-id-cell {\n  display: flex;\n  align-items: center;\n  gap: 8px;\n  white-space: nowrap;\n}\n\n.test-cases-table th.test-case-name-col,\n.test-cases-table td.test-case-name {\n  width: 280px;\n  max-width: 280px;\n  vertical-align: middle;\n}\n\n.test-cases-table th.environment-col,\n.test-cases-table td.environment-cell {\n  width: 140px;\n  max-width: 140px;\n  vertical-align: middle;\n}\n\n/* Test Case Name */\n.test-case-name {\n  cursor: pointer;\n  color: #0066cc;\n  position: relative;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.test-case-name-text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.environment-text {\n  display: block;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n}\n\n.test-case-name:hover {\n  text-decoration: underline;\n  color: #004499;\n}\n\n.suite-link {\n  color: var(--primary-color, #007bff);\n  text-decoration: none;\n}\n\n.suite-link:hover {\n  text-decoration: underline;\n}\n\n/* Status and Priority Badges */\n.status-badge,\n.priority-badge {\n  display: inline-block;\n  padding: 0.15rem 0.35rem;\n  border-radius: 10px;\n  font-size: 0.7rem;\n  font-weight: 500;\n}\n\n.status-badge.status-passed {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.status-badge.status-failed {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.status-badge.status-pending {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n}\n\n.priority-badge.priority-high {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n.priority-badge.priority-medium {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n}\n\n.priority-badge.priority-low {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n/* Pass Rate */\n.pass-rate {\n  padding: 0.15rem 0.35rem;\n  border-radius: 10px;\n  font-size: 0.75rem;\n  font-weight: 500;\n}\n\n.pass-rate.high {\n  background-color: rgba(40, 167, 69, 0.1);\n  color: #28a745;\n}\n\n.pass-rate.medium {\n  background-color: rgba(255, 193, 7, 0.1);\n  color: #ffc107;\n}\n\n.pass-rate.low {\n  background-color: rgba(220, 53, 69, 0.1);\n  color: #dc3545;\n}\n\n/* Empty State */\n.test-cases-empty-state {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  text-align: center;\n  padding: 2.5rem 1.5rem;\n  color: var(--text-muted);\n}\n\n.test-cases-empty-state p {\n  margin: 0;\n  font-size: 0.9rem;\n}\n\n/* Action Feedback */\n.action-feedback {\n  position: fixed;\n  top: 1rem;\n  right: 1rem;\n  padding: 0.75rem 1rem;\n  border-radius: 6px;\n  background-color: white;\n  box-shadow: 0 2px 10px rgba(0, 0, 0, 0.1);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n  z-index: 1000;\n  animation: slideIn 0.3s ease;\n}\n\n.action-feedback.success {\n  border-left: 4px solid #28a745;\n}\n\n.action-feedback.error {\n  border-left: 4px solid #dc3545;\n}\n\n.action-feedback.info {\n  border-left: 4px solid #17a2b8;\n}\n\n.action-feedback button {\n  background: none;\n  border: none;\n  font-size: 1rem;\n  cursor: pointer;\n  color: var(--text-muted);\n}\n\n@keyframes slideIn {\n  from {\n    transform: translateX(100%);\n    opacity: 0;\n  }\n  to {\n    transform: translateX(0);\n    opacity: 1;\n  }\n}\n\n/* Loading and Error States */\n.loading-container,\n.error-container {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n  text-align: center;\n}\n\n.loading-spinner {\n  width: 40px;\n  height: 40px;\n  border: 3px solid rgba(0, 0, 0, 0.1);\n  border-radius: 50%;\n  border-top-color: var(--primary-color, #007bff);\n  animation: spin 1s ease-in-out infinite;\n  margin-bottom: 1rem;\n}\n\n@keyframes spin {\n  to {\n    transform: rotate(360deg);\n  }\n}\n\n.error-icon {\n  font-size: 2rem;\n  margin-bottom: 1rem;\n}\n\n/* Responsive Adjustments */\n@media (max-width: 768px) {\n  .test-cases-stats-summary {\n    flex-wrap: wrap;\n  }\n  \n  .stat-card {\n    flex: 1 0 40%;\n    margin-bottom: 1rem;\n  }\n  \n  .project-header-stats {\n    flex-wrap: wrap;\n    justify-content: flex-end;\n  }\n}\n\n@media (max-width: 576px) {\n  .test-cases-overview-header {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .test-cases-overview-actions {\n    margin-top: 1rem;\n    width: 100%;\n  }\n  \n  .project-header-main {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n  \n  .expand-toggle {\n    position: absolute;\n    top: 1rem;\n    right: 1rem;\n  }\n  \n  .project-card {\n    position: relative;\n  }\n}\n\n.filter-loading {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  pointer-events: none;\n}\n\n.spinner-small {\n  width: 16px;\n  height: 16px;\n  border: 2px solid #f3f3f3;\n  border-top: 2px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n}\n\n@keyframes spin {\n  0% { transform: rotate(0deg); }\n  100% { transform: rotate(360deg); }\n}\n\n/* Test Cases Loading Styles */\n.test-cases-loading {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  padding: 3rem 1rem;\n  text-align: center;\n  color: #666;\n}\n\n.test-cases-loading .loading-spinner {\n  width: 32px;\n  height: 32px;\n  border: 3px solid #f3f3f3;\n  border-top: 3px solid #007bff;\n  border-radius: 50%;\n  animation: spin 1s linear infinite;\n  margin-bottom: 1rem;\n}\n\n.test-cases-loading p {\n  margin: 0;\n  font-size: 0.9rem;\n  color: #666;\n}\n\n/* Search Loading Styles */\n.search-loading {\n  position: absolute;\n  right: 8px;\n  top: 50%;\n  transform: translateY(-50%);\n  z-index: 1;\n  pointer-events: none;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
